import React, { useContext } from 'react';
import { AppSidebar, AppSidebarMenuItem } from '@redpanda/ui';
import {
  PresentationChartBarIcon,
  BriefcaseIcon,
  ListBulletIcon,
  BanknotesIcon,
  ClockIcon,
  BellIcon,
  ChartPieIcon,
} from '@heroicons/react/24/outline';
import { useNotificationStore, useNotificationPolling } from '../stores/notificationStore';
import ThemeSelector from './ThemeSelector';
import { UserContext } from '../context/UserContext';
import { useTranslation } from 'react-i18next';
import { Language } from '@redpanda/types';
import { isAdmin } from '@redpanda/utils';

interface SidebarProps {
  className?: string;
  isMobileOpen?: boolean;
  onCloseMobile?: () => void;
}

const menuItems: AppSidebarMenuItem[] = [
  { path: '/', labelKey: 'navbar.dashboard', icon: PresentationChartBarIcon },
  { path: '/projects', labelKey: 'navbar.projects', icon: BriefcaseIcon },
  { path: '/tasks', labelKey: 'navbar.tasks', icon: ListBulletIcon },
  { path: '/timesheets', labelKey: 'navbar.timesheets', icon: ClockIcon },
  { path: '/receivables', labelKey: 'navbar.receivables', icon: BanknotesIcon },
];

const Sidebar: React.FC<SidebarProps> = (props) => {
  const { user, logout, updateUserLanguage } = useContext(UserContext)!;
  const { i18n } = useTranslation();
  useNotificationPolling();
  const unread = useNotificationStore(state => state.unread);
  // 利潤報表只給管理員（成本資料）
  const items = [
    ...menuItems,
    ...(isAdmin(user?.role) ? [{ path: '/profitability', labelKey: 'navbar.profitability', icon: ChartPieIcon }] : []),
    { path: '/notifications', labelKey: 'navbar.notifications', icon: BellIcon, badge: unread },
  ];

  return (
    <AppSidebar
      appName="RedPanda PM"
      menuItems={items}
      user={user}
      currentLanguage={i18n.language}
      onLanguageChange={(lng) => {
        if (updateUserLanguage) updateUserLanguage(lng as Language);
        else i18n.changeLanguage(lng);
      }}
      onLogout={logout}
      themeSelector={<ThemeSelector />}
      currentSystem="PM"
      {...props}
    />
  );
};

export default Sidebar;
